import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-clientwala',
  templateUrl: './clientwala.component.html',
  styleUrls: ['./clientwala.component.css']
})
export class ClientwalaComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  customer = [
    {
      customerName: "Mr. Rohan Mehta",
      customerOccupation: "Senior Operations Manager, Reliance Jio",
      customerComment: `“The AI-powered unified dashboard has transformed the way we monitor and manage our nationwide operations. Real-time analytics, automated insights, and intelligent alerts have drastically reduced response time. Excellent innovation!”`,
      rating: 5
    },
    {
      customerName: "Mr. Anil Mohenti",
      customerOccupation: "HR Head, Falcon",
      customerComment: `“The HRMS portal we are using is more optimal and modern. It is time efficient and improve the productiblity of our team. This covers all our major operations and analyze it and report it properly.”`,
      rating: 5
    },
    {
      customerName: "Mr. Pramod Sahu",
      customerOccupation: "SVP, CIMPL",
      customerComment: `“ The logistics portal is extremely user-friendly and has streamlined our daily operations. Real-time tracking, automated reports, and quick navigation have improved our team’s productivity. Excellent work by the development team! ”`,
      rating: 5
    },
    {
      customerName: "Mr. Aditya Krishna Reddy",
      customerOccupation: "Director, GVPR",
      customerComment: `“ We really appreciate how the system simplifies dispatch workflows. Assigning drivers, monitoring trips, and updating statuses are now very quick. This portal has greatly improved our turnaround time. ”`,
      rating: 5
    },
    {
      customerName: "Mr. Suneet Patel",
      customerOccupation: "CEO, GRM",
      customerComment: `“We really appreciate how system simplifies and make the process of invoice, e-way bill much faster and smarter. This portal saves a lot of time and make our work more easier.”`,
      rating: 4
    },
    {
      customerName: "Ms. Riya Kapoor",
      customerOccupation: "Salon Owner, GlamStudio Salon",
      customerComment: `“FIFM software has completely simplified our appointment booking process. Clients can easily book their slots online, and our staff gets real-time updates. No more double bookings or confusion—this system is a game changer for salon operations.”`,
      rating: 4
    },
    {
      customerName: "Mr. Sagar Kulkarni",
      customerOccupation: "Operations & Technology Lead, Vi (Vodafone Idea)",
      customerComment: `“The AI-driven unified dashboard has simplified complex data into actionable insights. From traffic monitoring to service quality tracking, everything is accessible in one place. Our teams are now able to make faster, more accurate decisions. This platform has significantly improved operational efficiency.”`,
      rating: 4
    },
  ];

  currentSlide = 0;
  highlightedSlide: number | null = null;

  direction: 1 | -1 = 1;
  scrollSpeed = 0.5; // pixels per frame
  animationFrameId: any;
  isPaused = false;
  highlightTimeoutId: any;

  scrollbarWidth: number = 0;
  scrollbarPosition: number = 0;

  ngOnInit(): void { }

  // Add after ViewChild declaration
  ngAfterViewInit(): void {
    this.calculateScrollbar();
    this.startAutoScroll();

    const container = this.scrollContainer.nativeElement;
    container.addEventListener('scroll', () => {
      this.calculateScrollbar();
    });
  }

  ngOnDestroy(): void {
    cancelAnimationFrame(this.animationFrameId);
    if (this.highlightTimeoutId) clearTimeout(this.highlightTimeoutId);
  }

  calculateScrollbar() {
    const container = this.scrollContainer.nativeElement;
    const scrollWidth = container.scrollWidth - container.clientWidth;

    // Calculate width percent of scrollbar thumb (visible area proportion)
    this.scrollbarWidth = (container.clientWidth / container.scrollWidth) * 100;

    // Calculate left position percent of scrollbar thumb
    this.scrollbarPosition = (container.scrollLeft / scrollWidth) * (100 - this.scrollbarWidth);
  }

  startAutoScroll() {
    const container = this.scrollContainer.nativeElement;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    const step = () => {
      if (!this.isPaused && this.highlightedSlide === null) {
        container.scrollLeft += this.scrollSpeed * this.direction;

        if (container.scrollLeft >= maxScrollLeft) {
          this.direction = -1;
        } else if (container.scrollLeft <= 0) {
          this.direction = 1;
        }
      }
      this.animationFrameId = requestAnimationFrame(step);
    };

    step();
  }

  pauseScroll() {
    this.isPaused = true;
  }

  resumeScroll() {
    if (this.highlightedSlide === null) {
      this.isPaused = false;
    }
  }

  onCardClick(index: number) {
    if (this.highlightedSlide === index) {
      this.clearHighlight();
      return;
    }

    this.highlightedSlide = index;
    this.isPaused = true;
    this.scrollToCard(index);

    if (this.highlightTimeoutId) clearTimeout(this.highlightTimeoutId);
    this.highlightTimeoutId = setTimeout(() => {
      this.clearHighlight();
    }, 10000);
  }

  clearHighlight() {
    this.highlightedSlide = null;
    this.isPaused = false;
    this.direction = (this.direction * -1) as 1 | -1;
  }

  scrollToCard(index: number) {
    const container = this.scrollContainer.nativeElement;
    const card = container.children[index] as HTMLElement;
    if (card) {
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const containerCenter = container.clientWidth / 2;
      const scrollTo = cardLeft - containerCenter + cardWidth / 2;
      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }
  }

}
